export default __webpack_public_path__ + "static/media/Illustrator.ce5d6f87.png";